import QuestionnaireIcon from './Questionnaire'
import ArrowIcon from './Arrow'
import QuestionnaireArrowIcon from './QuestionnaireArrow'

export default {
    QuestionnaireIcon,
    ArrowIcon,
    QuestionnaireArrowIcon
}
